module.exports = __webpack_public_path__ + "static/media/train_3.5be73ecd.png";